import React, { forwardRef } from 'react'
import { useIntl } from 'react-intl'
import { mergeRefs } from 'react-merge-refs'
import { useFlash } from 'hooks/flash'
import { onClink } from 'utilities/event'
import { sendAppSignal } from 'hooks/app-signal'
import { SlimDocument, NameCell, EditLink, ConcernsSummary } from './s'
import FileNameIcon from 'components/file-name-icon'
import { getFullName } from 'utilities/person'

const SlimDocumentItem = forwardRef(({ dokument, flash }, ref) => {
    const { formatMessage } = useIntl()

    const flasher = useFlash(flash)

    let concernsName
    if(dokument.concerns) {
        concernsName = formatMessage({
            id: 'document_regarding_person',
            defaultMessage: 'Regarding {person}'
        }, { person: getFullName(dokument.concerns) })
    }

    return (
        <SlimDocument ref={mergeRefs([ref, flasher])}>
            <NameCell>
                <EditLink
                    to={`${global.location.pathname}?id=${dokument.id}`}
                    onClick={onClink(() => sendAppSignal('document:preview', dokument))}>
                    <FileNameIcon
                        name={dokument.name}
                        extension={dokument.extension ?? dokument.type}
                        inline={true} />
                    {concernsName && (
                        <ConcernsSummary>{concernsName}</ConcernsSummary>
                    )}
                </EditLink>
            </NameCell>
        </SlimDocument>
    )
})

export default SlimDocumentItem